import Vue from 'vue'
import App from './app.vue'
import router from './router'
import i18n from './i18n'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'

import './styles/element-ui.scss'
import './styles/common.scss'

Vue.use(ElementUI, { locale });

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');